import { createSlice } from '@reduxjs/toolkit';
import {
  updateSurvey,
  createSurvey,
  fetchSavedDeliverySettings,
  fetchEstimatedDeliveryTargetCounts,
  updatedTargetSamples,
  updatedNumberOfQuestions,
  changeSurveyStatus,
  logoutAdmin,
  logoutUser,
} from '~/api';
import { USER_CATEGORY } from '~/common/constants';
import { SURVEY_TYPE } from '~/constants';

const initialState = {
  id: null,
  name: '',
  url: '',
  type: SURVEY_TYPE.GOOGLE_FORM,
  numberOfQuestions: 0,
  targetSamplesTotal: 0,
  surveyStatusId: null,
  surveyStatusName: '',
  specialPanelDisplaySettingId: null,
  deliveryDate: '',
  created: '',
  modified: '',
  moResearchId: null,
  rejectedReason: '',
  userId: null,
  userName: '',
  userEmail: '',
  userCategory: USER_CATEGORY.INDIVIDUAL,
  userCompanyName: '',
};

const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    initialize: () => initialState,

    updated: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchSavedDeliverySettings.fulfilled.type]: (state, action) => {
      return {
        ...state,
        ...action.payload.survey,
        targetSamplesTotal: action.payload.targetSamplesTotal,
      };
    },

    // APIから作成後のsurveyが返ってくるので、それでstateのsurveyを更新。
    [createSurvey.fulfilled.type]: (state, action) => {
      const { result: survey } = action.payload;
      return {
        ...state,
        id: survey.id,
        name: survey.name,
        url: survey.url,
        type: survey.type,
        numberOfQuestions: survey.numberOfQuestions,
        surveyStatusId: survey.surveyStatusId,
        surveyStatusName: survey.surveyStatusName,
        specialPanelDisplaySettingId: survey.specialPanelDisplaySettingId,
        deliveryDate: survey.deliveryDate,
        created: survey.created,
        modified: survey.modified,
        moResearchId: survey.moResearchId,
        userId: survey.userId,
        userName: survey.userName,
        userEmail: survey.userEmail,
        userCategory: survey.userCategory,
        userCompanyName: survey.userCompanyName,
      };
    },

    // APIから更新後のsurveyが返ってくるので、それでstateのsurveyを更新。
    [updateSurvey.fulfilled.type]: (state, action) => {
      return {
        ...state,
        ...action.payload.survey,
      };
    },

    /**
     * 対象者検索ボタンがクリックされた時にトリガーされるAction後のstate更新。
     * targetSamplesTotalは0になる。
     */
    [fetchEstimatedDeliveryTargetCounts.fulfilled.type]: (state, action) => {
      // 過去データ復帰直後の検索及び、管理者によるステータス却下の場合は、targetSamplesTotalを0にしない。
      if (action.payload.isReconstructing) {
        return state;
      }
      return {
        ...state,
        targetSamplesTotal: 0,
      };
    },

    /**
     * 配信設定画面で回答希望数の内訳が変更された時にトリガーされるAction後のstate更新。
     */
    [updatedTargetSamples.fulfilled.type]: (state, action) => {
      return {
        ...state,
        targetSamplesTotal: action.payload.targetSamplesTotal,
      };
    },

    [updatedNumberOfQuestions.fulfilled.type]: (state, action) => {
      return {
        ...state,
        ...action.payload.survey,
      };
    },

    [changeSurveyStatus.fulfilled.type]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    [logoutAdmin.fulfilled.type]: () => {
      return initialState;
    },

    [logoutUser.fulfilled.type]: () => {
      return initialState;
    },
  },
});

// reducerをexportする
export default surveySlice.reducer;
